import Cookies from 'js-cookie';

// Function to set a cookie
export function setCookie(name, value, expirationInSeconds = 3600, domain) {
  const date = new Date();
  date.setTime(date.getTime() + expirationInSeconds * 1000);
  const cookieOptions = {
    expires: new Date(date), // Convert the expiration date to a Date object
    path: '/',
    domain: domain,
    secure: window.location.protocol === 'https:',
  };

  Cookies.set(name, value, cookieOptions);
}

// Function to get the value of a cookie with the specified name
export function getCookie(name) {
  const cookieValue = Cookies.get(name);
  return cookieValue || null;
}

// Function to remove a cookie with the specified name
export function removeCookie(name, domain) {
  const cookieOptions = {
    path: '/',
    domain: domain,
    secure: window.location.protocol === 'https:',
  };

  Cookies.remove(name, cookieOptions);
}
